// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.io {
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features -- reported as partial support */
  column-gap: 10px;

  flex-wrap: wrap;
  justify-content: space-between;
  color: gray;

  &[data-empty="true"] {
    display: none;
  }

  & > * {
    flex-grow: 1;
    flex-basis: 1px;
  }

  & > label {
    flex-grow: 0; /* Override for label */
    flex-basis: 80px; /* Override for label */

    text-align: right;
    font-size: smaller;
    overflow-wrap: break-word;
    hyphens: auto;
  }

  & > .content {
    text-align: left;
    background-color: white;
    overflow-wrap: break-word;

    max-width: calc(100% - 25% - 10px);

    & > .with-newlines {
      white-space: pre-wrap;
    }

    & > input {
      margin: 0 auto;
      border: 1px solid var(--color-border);

      &:invalid {
        border: 1px solid red;
      }

      &[type="checkbox"] {
        height: 1.5em;
        width: 1.5em;
        border-radius: 25%;
        margin-right: 5px;
      }
    }

    & > .io-error {
      color: red;
      font-size: smaller;
      display: block;
      margin-top: 5px;
    }

    & > select {
      border: 1px solid var(--color-border);
    }

    & > .radio-buttons {
      display: flex;
      flex-direction: row;
      align-items: center;

      & > input[type="radio"] {
        height: 1.5em;
        width: 1.5em;
        margin-right: 5px;
        appearance: auto;
      }
    }

    &:not(:first-child) {
      font-size: smaller;
    }
  }

  &.io-note {
    font-size: smaller;
  }

  &.io-output {
    & > .content > :first-child {
      color: var(--color-around-green);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/widget/io-abstract.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sGAAsG;EACtG,gBAAgB;;EAEhB,eAAe;EACf,8BAA8B;EAC9B,WAAW;;EAEX;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY,EAAE,uBAAuB;IACrC,gBAAgB,EAAE,uBAAuB;;IAEzC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;;IAEzB,kCAAkC;;IAElC;MACE,qBAAqB;IACvB;;IAEA;MACE,cAAc;MACd,qCAAqC;;MAErC;QACE,qBAAqB;MACvB;;MAEA;QACE,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;MACnB;IACF;;IAEA;MACE,UAAU;MACV,kBAAkB;MAClB,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;;MAEnB;QACE,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;MAClB;IACF;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE;MACE,gCAAgC;IAClC;EACF;AACF","sourcesContent":[".io {\n  display: flex;\n  flex-direction: row;\n  padding: 5px 10px;\n  /* stylelint-disable-next-line plugin/no-unsupported-browser-features -- reported as partial support */\n  column-gap: 10px;\n\n  flex-wrap: wrap;\n  justify-content: space-between;\n  color: gray;\n\n  &[data-empty=\"true\"] {\n    display: none;\n  }\n\n  & > * {\n    flex-grow: 1;\n    flex-basis: 1px;\n  }\n\n  & > label {\n    flex-grow: 0; /* Override for label */\n    flex-basis: 80px; /* Override for label */\n\n    text-align: right;\n    font-size: smaller;\n    overflow-wrap: break-word;\n    hyphens: auto;\n  }\n\n  & > .content {\n    text-align: left;\n    background-color: white;\n    overflow-wrap: break-word;\n\n    max-width: calc(100% - 25% - 10px);\n\n    & > .with-newlines {\n      white-space: pre-wrap;\n    }\n\n    & > input {\n      margin: 0 auto;\n      border: 1px solid var(--color-border);\n\n      &:invalid {\n        border: 1px solid red;\n      }\n\n      &[type=\"checkbox\"] {\n        height: 1.5em;\n        width: 1.5em;\n        border-radius: 25%;\n        margin-right: 5px;\n      }\n    }\n\n    & > .io-error {\n      color: red;\n      font-size: smaller;\n      display: block;\n      margin-top: 5px;\n    }\n\n    & > select {\n      border: 1px solid var(--color-border);\n    }\n\n    & > .radio-buttons {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n\n      & > input[type=\"radio\"] {\n        height: 1.5em;\n        width: 1.5em;\n        margin-right: 5px;\n        appearance: auto;\n      }\n    }\n\n    &:not(:first-child) {\n      font-size: smaller;\n    }\n  }\n\n  &.io-note {\n    font-size: smaller;\n  }\n\n  &.io-output {\n    & > .content > :first-child {\n      color: var(--color-around-green);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
